import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import React from 'react';
import {NyTooltip} from 'nyse-web-tools-common/lib/react';

// Page chrome rather than a cell tooltip on the Update Status column: an appointment
// submitted inside a GBO hold window produces no row at all until the sweeping job runs,
// so there is no status cell to attach the explanation to.
//
// The windows are described rather than computed from the clock because the offsets are
// GBO server config (CS 11009.12.1.4, 11009.12.2.5 - per-MIC, changed by ticket) and XNYS
// resolves on a different auction class, so a computed message would drift on half-days,
// holidays and DST. The closing-auction qualifier is needed because CS 11009.12.3.4 puts
// Options at ~16:15 against ~16:00 for Equities and this screen serves both.
export const MmAppointmentHoldWindowInfoTooltip = () => {
    return (
        <NyTooltip
            enterDelay={500}
            trigger={['hover']}
            overlay={
                <div className='definition-tooltip flex-column'>
                    <h4 className='m-0'>Why a new appointment may not appear yet</h4>
                    <ul style={{marginLeft: '10px', listStyleType: 'disc'}}>
                        <li>All Add msgs sent during core opening auction will be held until 9:40 a.m.</li>
                        <li>All delete msgs received after 9:25 a.m. will be processed for next day only.</li>
                        <li>All msgs (adds &amp; deletes) received after 4 p.m. will be processed for next day only.</li>
                    </ul>
                    <span>Times are approximate and set per market; the Options closing auction is ~4:15 p.m.</span>
                </div>
            }>
            <InfoOutlinedIcon
                data-e2e-tag='mmAppointmentHoldWindowInfoTooltip'
                className='space-right-1'
                fontSize='small'
            />
        </NyTooltip>
    );
};
